import { render, staticRenderFns } from "./memberList.vue?vue&type=template&id=50e45a60&class=full-height&"
import script from "./memberList.vue?vue&type=script&lang=js&"
export * from "./memberList.vue?vue&type=script&lang=js&"
import style0 from "./memberList.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50e45a60')) {
      api.createRecord('50e45a60', component.options)
    } else {
      api.reload('50e45a60', component.options)
    }
    module.hot.accept("./memberList.vue?vue&type=template&id=50e45a60&class=full-height&", function () {
      api.rerender('50e45a60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/auth/member/components/memberList.vue"
export default component.exports